import React, { use } from 'react';
import { useTranslation } from 'react-i18next';
import LoadingIndicator from 'shared/components/loading-indicator/loading-indicator';
import PageHeader from 'shared/components/page-header/page-header';

import LocationFeatureSubscriptionsDetails from './components/location-feature-subscriptions-details/location-feature-subscriptions-details';
import LocationFeatureSubscriptions from './components/location-feature-subscriptions/location-feature-subscriptions';
import TenantFeatureSubscriptions from './components/tenant-feature-subscriptions/tenant-feature-subscriptions';
import LocationFeatureSubscriptionsProviderContext from './contexts/location-feature-subscriptions-provider-context';
import TenantFeatureSubscriptionsProviderContext from './contexts/tenant-feature-subscriptions-provider-context';
import styles from './feature-subscriptions.module.scss';

const FeatureSubscriptions = (): React.JSX.Element => {
  const { t } = useTranslation('featureSubscriptions');

  const { readTenantFeatureSubscriptionsIsLoading } = use(TenantFeatureSubscriptionsProviderContext);
  const { readLocationFeatureSubscriptionsIsLoading } = use(LocationFeatureSubscriptionsProviderContext);

  const isLoading = readTenantFeatureSubscriptionsIsLoading || readLocationFeatureSubscriptionsIsLoading;

  return (
    <>
      <PageHeader title={t('pageTitle')} />
      <div className={styles.container}>
        <div className={styles.leftContent}>
          <TenantFeatureSubscriptions />
          <LocationFeatureSubscriptions />
        </div>
        <LocationFeatureSubscriptionsDetails />
      </div>
      {isLoading && <LoadingIndicator />}
    </>
  );
};

export default FeatureSubscriptions;
